import  * as pdf_util from './utils/pdf_util';
pdf_util.globalRender();